import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, Stack, Typography } from '@mui/material';
import { EnhancedDialog } from 'components/enhanced';
import { useTranslation } from 'react-i18next';
import { TextCancelButton } from '../buttons/CancelButton';
import { TextConfirmButton } from '../buttons/ConfirmButton';

interface ConfirmationDeleteDialogContentProp {
  openDialog;
  message;
  handleCloseDialog;
  handleConfirmDelete;
  onClick?;
}
export default function ConfirmationDeleteDialogContent({
  openDialog,
  message,
  handleCloseDialog,
  handleConfirmDelete,
  onClick
}: ConfirmationDeleteDialogContentProp) {
  const { t } = useTranslation();

  return (
    <>
      <EnhancedDialog
        open={openDialog}
        onClose={handleCloseDialog}
        onClick={onClick}
        title={t('actions.confirmation.delete', 'Conferma Eliminazione')}
        maxWidth="xs"
        costumFooter={
          <Stack direction="row" spacing={1.5} sx={{ width: '100%' }}>
            <TextCancelButton handleCloseDialog={handleCloseDialog} />
            <TextConfirmButton handleConfirm={handleConfirmDelete} />
          </Stack>
        }>
        <Stack direction="column" alignItems="center" spacing={2} sx={{ textAlign: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(211, 47, 47, 0.06)',
              color: 'error.main',
              p: 2,
              borderRadius: '50%',
              border: '1px solid',
              borderColor: 'rgba(211, 47, 47, 0.12)'
            }}>
            <WarningAmberRoundedIcon sx={{ fontSize: 46 }} />
          </Box>

          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.6,
                whiteSpace: 'pre-line',
                px: 1
              }}>
              {message ||
                t('messages.warning.generic_delete', "L'azione non potrà essere annullata.")}
            </Typography>
          </Box>
        </Stack>
      </EnhancedDialog>
    </>
  );
}
